import { render, staticRenderFns } from "./monitorList.vue?vue&type=template&id=24106388&scoped=true"
import script from "./monitorList.vue?vue&type=script&lang=js"
export * from "./monitorList.vue?vue&type=script&lang=js"
import style0 from "./monitorList.vue?vue&type=style&index=0&id=24106388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24106388",
  null
  
)

export default component.exports